import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
export class HeaderModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [CommonModule],
  declarations: [HeaderComponent],
  exports: [
    HeaderComponent // <-- 导出组件 Export our component from our module
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function HeaderModule_tsickle_Closure_declarations() {
/** @type {?} */
HeaderModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
HeaderModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
